import * as _ from "lodash";
export class AdminPageComponent implements ng.IComponentOptions {
    public controller: any = AdminController;
    public template: string =
    `<div class="container container-fluid padding-2">
        <breadcrumb tree="$ctrl.tree"></breadcrumb>
        <div class="wrapper row">
        <div class="col-sm-3 sidebar">
          <div class="section-header">Navigation</div>
          <div class="section-content">
           <ul class="nav nav-pills nav-stacked">
            <li ng-class="{'active':nv.active}"  ng-repeat="nv in $ctrl.nav">
              <a ng-href="{{nv.path}}">{{nv.name}}</a>
              <ul class="subnav" ng-show="nv.sub" uib-collapse="!nv.active">
                <li ng-repeat="subnv in nv.sub"><a ng-href="{{subnv.path}}" ng-class="{'active':(subnv.path === $ctrl.currentPath)||!$index&&!$ctrl.subPath}">{{subnv.name}}</a></li>
              </ul>
            </li>
           </ul>
          </div>
        </div>
        <div class="col-sm-9">
        <div ui-view="admin"></div>
        </div>
      </div>
    </div>`;
}
export class AdminController {
    public static $inject: Array<string> = ["$scope", "$location"];
    public tree: Array<Object>;
    public form: any;
    public error: any;
    private commonTree: any;
    public nav: any;
    public currentPath: string;
    public subPath: string;

    constructor($scope: ng.IScope, $location: ng.ILocationService) {
      this.tree = [
        {name: "Administration", path: "#/admin"}
      ];
      this.commonTree = {
        user: {name: "User Management", path: "#/admin/user/", active: true},
        org: {name: "Organisation Management", path:"#/admin/organization/", active: true},
        cat: {name: "Classification Management", path:"#/admin/classification/", active: true},
        data: {name: "Data Management", path:"#/admin/data/", active: true},
        external: {name: "External Dataset", path: "#/admin/external", active: true},
        config: {name: "Configuration Management", path:"#/admin/configuration/", active: true},
        report: {name: "Report", path:"#/admin/report/", active: true}
      }
      this.nav = [
        {name: "User Management", path: "#/admin/user/", type: "user", sub: [
          {name: "Data Provider (Ministry/Agency)", path: "#/admin/user/internal"},
          {name: "Organisation (Public)", path: "#/admin/user/external_org"},
          {name: "Individual (Public)", path: "#/admin/user/external"}
        ]},
        {name: "Organisation Management", path: "#/admin/organization/", type: "org", sub: [
          {name: "Ministry", path: "#/admin/organization/ministry"},
          {name: "Agency", path: "#/admin/organization/agency"}
        ]},
        {name: "Classification Management", path: "#/admin/classification/", type: "cat", sub: [
          {name: "Group", path: "#/admin/classification/group"},
          {name: "Category", path: "#/admin/classification/category"},
          {name: "User Type", path: "#/admin/classification/user_type"},
          {name: "Organisation Type", path: "#/admin/classification/organisation_type"},
          {name: "Feedback Type", path: "#/admin/classification/feedback_type"},
          {name: "Purpose", path: "#/admin/classification/purpose"}
        ]},
        {name: "Dataset Management", path: "#/admin/data/", type: "data", sub: [
          {name: "Dataset Type", path: "#/admin/data/datatype"},
          {name: "Data Submission Monitoring", path: "#/admin/data/submission"}
        ]},
        {name: "External Dataset", path: "#/admin/external", type: "external"},
        {name: "Configuration Management", path: "#/admin/configuration", type: "config"},
        {name: "Summary Datasets", path: "#/admin/report/", type: "report", sub: [
          {name: "Summary Dataset by Agencies vs Category", path: "#/admin/report/1"},
          {name: "Dataset Status by Agencies", path: "#/admin/report/2"},
          {name: "Dataset Popularity", path: "#/admin/report/3"},
          {name: "Statistic Download Report", path: '#/admin/report/4'},
          {name: "Dataset Activity Stream", path: '#/admin/report/5'},
          {name: "User Registration Tracking", path: '#/admin/report/6'}
        ]}
      ];
      this.error = {};
      this.currentPath = "#" + $location.path();
      this.subPath = $location.path().split('/')[3];
      $scope.$on("adminPageChange", (ev, data) => {
        if (this.tree.length > 1) {
          this.tree.pop();
        }
        this.tree.push(this.commonTree[data.name]);
        this.setActive(data.name);
        this.currentPath = "#" + $location.path();
        this.subPath = $location.path().split('/')[3];
      })
    }

    private setActive(type: String) {
      _.each(this.nav, (nav) => {
        if(nav.type == type)
          nav.active = true;
        else
          nav.active = false;
      })
    }

}
